document.addEventListener("DOMContentLoaded", function () {

    // Toggle Between CM And Inches
    document.querySelectorAll("ul.tabs li").forEach(tab => {
        tab.addEventListener("click", function () {
            const tab_id = this.getAttribute("data-tab");

            document.querySelectorAll("ul.tabs .current").forEach(el => {
                el.classList.remove("current");
            });

            this.classList.add("current");

            if (tab_id === "tab-2") {
                updateInchesCm("cm");
            } else {
                updateInchesCm("in");
            }
        });
    });

    let result = {
        bust: false,
        waist: false,
        hips: false,
    };

    // Fetch Inputs Values
    document.querySelectorAll(".inner_input input").forEach(input => {
        input.addEventListener("keyup", function () {
            const idname = this.id;
            const value = parseFloat(this.value);

            if (!isNaN(value)) {
                if (idname === "bust_id") {
                    selectTD(".Bust_td td", value, idname);
                    areAllValuesTrue(result);
                } else if (idname === "waist_id") {
                    selectTD(".Waist_td td", value, idname);
                    areAllValuesTrue(result);
                } else if (idname === "hips_id") {
                    selectTD(".Hips_td td", value, idname);
                    areAllValuesTrue(result);
                }
            }
        });
    });

    function updateInchesCm(sizeName) {
        const targetSize = sizeName === "in" ? "data-bst" : "data-bst-cm";

        document.querySelectorAll("tbody .td-val").forEach(element => {
            const value = element.getAttribute(targetSize);
            element.textContent = `${value}${sizeName === "in" ? '"' : ""}`;
        });
    }

    function areAllValuesTrue(obj) {
        if (Object.values(obj).every(value => Number.isInteger(value))) {
            if (isGapMoreThanTwo(obj.bust, obj.waist, obj.hips)) {
                const maxIndex = Math.max(obj.bust, obj.waist, obj.hips);
                const targetEL = document.querySelectorAll(".table_inches_index td")[maxIndex];

                if (targetEL) {
                    const recommendSize = targetEL.getAttribute("data-size");
                    document.getElementById("size-result").textContent = recommendSize;
                }
            } else {
                document.getElementById("size-result").textContent = "Size Not Available";
            }
        }
    }

    function isGapMoreThanTwo(num1, num2, num3) {
        const diff1 = Math.abs(num2 - num1);
        const diff2 = Math.abs(num3 - num2);
        const diff3 = Math.abs(num3 - num1);
        return !(diff1 > 2 || diff2 > 2 || diff3 > 2);
    }

    function selectTD(selector, value, idname) {
        const currentTab = document.querySelector(".tabs .current")?.getAttribute("data-tab");
        const targetSize = currentTab === "tab-1" ? "data-bst" : "data-bst-cm";

        const tds = document.querySelectorAll(selector);

        for (let index = 0; index < tds.length; index++) {
            const td = tds[index];
            const bts = parseFloat(td.getAttribute(targetSize));

            td.classList.remove("active");

            if (bts >= value) {
                td.classList.add("active");

                if (idname === "bust_id") {
                    result.bust = index;
                } else if (idname === "waist_id") {
                    result.waist = index;
                } else if (idname === "hips_id") {
                    result.hips = index;
                }
                break;
            } else {
                if (idname === "bust_id") result.bust = false;
                if (idname === "waist_id") result.waist = false;
                if (idname === "hips_id") result.hips = false;
            }
        }
    }

});